import React from 'react'

const CheckboxWrapper = React.forwardRef((props, ref) => (
  <label className='region-checkbox'>
    <input type='checkbox' {...props} ref={ref} />
    <div className='checkbox-text'>{props.label}</div>
  </label>
))

export default CheckboxWrapper
